import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import NavItem from './components/NavItem';
import PrimaryButton from 'components/buttons/PrimaryButton';
import LoginIcon from '@mui/icons-material/Login';

const SidebarNav = ({ pages }) => {
    const {
        about: aboutPages,
        program: programPages,
        submission: abstractPages,
        gallery: galleryPages,
    } = pages;
    return (
        <Box>
            <Box width={1} paddingX={2} paddingY={1}>
                <Link to={'/'} style={{ textDecoration: 'none' }}>
                    <Box
                        display={'flex'}
                        component="a"
                        title="Ina ACC"
                        width={{ xs: 180, md: 200 }}
                    >
                        <Box
                            component={'img'}
                            src={`${process.env.PUBLIC_URL}/logo-semarang.webp`}
                            height={1}
                            width={1}
                        />
                    </Box>
                </Link>
            </Box>
            <Box paddingX={2} paddingY={2}>
                <Box>
                    <NavItem title={'Program'} items={programPages} />
                </Box>
                <Box>
                    <NavItem title={'About'} items={aboutPages} />
                </Box>
                <Box>
                    <NavItem
                        title={'Abstract Submission'}
                        items={abstractPages}
                    />
                </Box>
                <Box>
                    <NavItem title={'Gallery'} items={galleryPages} />
                </Box>
            </Box>
            <Box marginTop={2}>
                <PrimaryButton
                    size={'large'}
                    variant="contained"
                    fullWidth
                    component="a"
                    href="/signin"
                    sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
                >
                    <LoginIcon /> Sign In
                </PrimaryButton>
            </Box>
        </Box>
    );
};

SidebarNav.propTypes = {
    pages: PropTypes.object,
};

export default SidebarNav;
